import {customElement} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {NavigationRootItem, NavModel} from "./common/navModel";
import {resolve} from "../../../container";
import {UnLitElement} from "../../../common/elements";
import type {Nullable} from "../../../bootstrap/common/types";
import {trackingNavigationInteract} from "../../../tracking/trackingAttributes";

@customElement("eop-sector-identifier")
export class EopSectorIdentifier extends UnLitElement {


    private navRoot: NavigationRootItem;

    public constructor(navModel: NavModel = resolve(NavModel)) {
        super();
        this.navRoot = navModel.makeNavRoot();
    }

    public render(): Nullable<TemplateResult> {
        const activeSector = this.navRoot.getActiveSector();
        const sectorIdentifier = activeSector?.sectorIdentifier;

        if (!sectorIdentifier) {
            return html`
                <div class="alignment-placeholder">" "</div>
            `;
        }

        return html`
            <a class="link logo-sector"
               href=${activeSector.href}
               title=${sectorIdentifier}
               ${trackingNavigationInteract(sectorIdentifier, activeSector.href)}
            >
                <div class="sector-identifier">${sectorIdentifier}</div>
            </a>
        `;
    }
}